'use client';
import { getProductSlug } from '@qlevr/shared/mappers';
import Link from 'next/link';
import { useParams } from 'next/navigation';

export interface ProductTogProductsProps {
  handle?: string | null;
  children?: React.ReactNode;
  className?: string;
  title?: string | null;
}

export default function ProductLink({ handle, children, className, title }: ProductTogProductsProps) {
  const { locale } = useParams<{ locale: string }>();

  if (!handle) {
    return null;
  }

  const url = `/${locale}${getProductSlug(handle)}`;

  return (
    <Link href={url} className={className} title={title || ''}>
      {children || null}
    </Link>
  );
}
